export const COMPANY_NAME = '台州智赋网络科技有限公司'
export const COMPANY_SHORT_NAME = 'Ai智能体获客'



// WEBPACK FOOTER //
// ./src/constants/index.js